import React from "react";
import ProductRail from "web/react/components/product-rail/product-rail";
import styles from "./homepage-product-rail.css";

interface HomepageProductRailProps {
    title: string;
    products: any;
}

export function HomepageProductRail({ title, products }: HomepageProductRailProps): JSX.Element {
    return (
        <ProductRail
            className={styles.homepageRail}
            title={title}
            label="homepage-popular-products"
            products={products}
            type="homepage"
            features={{}}
            railClassName={styles.homepageRailList}
            id="product-rail"
            imageSize={"feed"}
        />
    );
}

export default HomepageProductRail;
